import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { WINDOW } from '@pin-up-global/common';
import { Observable } from 'rxjs';
import { getEncodedUrl } from '@shared/utils';
import { AccessData, AuthSession } from '../auth.abstraction';
import { AUTH_SESSION_KEY, STANDALONE_AUTH_TOKEN_KEY } from '../auth.constant';
import { AuthGrpcApiService } from '../auth-grpc-api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthUtilityService {
  #router = inject(Router);
  #window = inject(WINDOW);
  #authApiService = inject(AuthGrpcApiService);

  refresh(): Observable<Omit<AccessData, 'refresh'>> {
    return this.#authApiService.refresh(this.getRefreshToken());
  }

  getSignInUrlTree(): UrlTree {
    const { pathname, search } = this.#window.location;
    // TODO ask Dmytro where to redirect and which params to add
    const url = `/redirect?url=/?url=${ getEncodedUrl(`${pathname}${search}`) }`;

    return this.#router.parseUrl(url);
  }

  getPostSignInUrlTree(): UrlTree {
    return this.#router.parseUrl('/');
  }

  getAccessToken(): string | null {
    const sessionRaw = this.#window.localStorage.getItem(AUTH_SESSION_KEY);
    if (!sessionRaw) {
      return null;
    }

    try {
      const session: AuthSession = JSON.parse(sessionRaw);
      return session.access || null;
    } catch {
      return null;
    }
  }

  getRefreshToken(): string | null {
    const sessionRaw = this.#window.localStorage.getItem(AUTH_SESSION_KEY);
    if (!sessionRaw) {
      return null;
    }

    try {
      const session: AuthSession = JSON.parse(sessionRaw);
      return session.refresh || null;
    } catch {
      return null;
    }
  }

  removeTokens(): void {
    this.#window.localStorage.removeItem(AUTH_SESSION_KEY);
    this.#window.localStorage.removeItem(STANDALONE_AUTH_TOKEN_KEY);
  }

  saveTokens(access: string, refresh?: string): void {
    const refreshFromStorage = this.getRefreshToken();
    const refreshToken = refresh || refreshFromStorage;

    const session = refreshToken ? { access, refresh: refreshToken } : { access };

    this.#window.localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));

    // TODO save access token separately for flow-editor
    this.#window.localStorage.setItem(STANDALONE_AUTH_TOKEN_KEY, access);
  }
}
